export const downloadDeliveryWorkAttachmentEndpoint = (
  shipmentUid: string,
  visitId: number,
  attachmentId: number
) => `/shipments/${shipmentUid}/visits/${visitId}/delivery-work/attachments/${attachmentId}`
